const isPromise = (value: any) => !!value && typeof value.then === 'function';

export default isPromise;
